<template>
  <v-container style="padding: 0; margin: 0">
    <v-layout wrap flex>
      <v-flex
        xs12>
        <Topo :empresa="empresa"/>
        <v-card
          v-show="exportando_dados"
          :max-height="heightCard"
          :style="(exportando_dados)?'overflow: auto; background-color: #E1E1E1':'overflow: auto;'"
          class="mb-3"
        >
          <v-layout
            v-if="exportando_dados"
            :style="{'height': heightCard}"
            column
            fill-height
            justify-center
            align-center
          >
            <img
              :style="{'height': '200px'}"
              src="assets/videos/brcorte_caw.gif" >
          <!--
                    <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  >
                  </v-progress-circular>-->
          </v-layout>
        </v-card>
        <v-container
          v-show="!exportando_dados"
          grid-list-md>
          <v-layout
            flex
            row
            wrap>

            <v-flex
              id="colaboradores_area"
              md12
              xs12
              text-xs-center>
              <material-card
                :text="strings[idioma].clientes"
                :color="colorCard">
                <v-text-field
                  :label="strings[idioma].pesquisar"
                  v-model="searchColaboradores"
                  flat
                  hide-details
                  clearable
                  append-icon="mdi-magnify"
                  clear-icon="mdi-close"/>
                <v-divider/>
                <v-list
                  style="padding: 0; margin: 0; max-height: 250px; width: 100%; overflow:auto;"
                  dense
                  flat
                  rounded>
                  <v-list-tile
                    v-for="us in colaboradoresFilter"
                    :key="us.id"
                    flat
                    @click="openInfoVinculado(us)">
                    <v-list-tile-avatar>
                      <v-icon
                        v-text="'mdi-account'"
                      />
                    </v-list-tile-avatar>
                    <v-list-tile-action>
                      <span>{{ us.id }}</span>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ us.NOME }}
                      <v-list-tile-sub-title>{{ us.email }}</v-list-tile-sub-title>
                    </v-list-tile-content>

                  </v-list-tile>
                </v-list>
              </material-card>
            </v-flex>
            <v-layout
              v-if="currUser && currUser !== null"
              id="usr_area">
              <v-flex
                v-if="currUser !== null"
                id="colaboradores_area"
                :md12="currUser === null"
                :md6="currUser !== null"
                xs6
                text-xs-center>
                <material-card
                  :text="strings[idioma].usuario"
                  :color="colorCard">
                  <p>#{{ currUser.id }}</p>
                  <p>{{ currUser.NOME }}</p>
                  <p>{{ currUser.email }}</p>
                  <p v-if="currUser.cidade">{{ currUser.cidade + ' - '+currUser.estado+' - '+currUser.pais }}</p>
                  <p v-if="currUser.phone">{{ '+'+currUser.phone.cod_pais + '('+currUser.phone.DDD+')'+currUser.phone.telefone }}</p>
                  <p v-if="currUser.endereco">{{ currUser.endereco.cidade + ' - '+currUser.endereco.estado+' - '+currUser.endereco.pais }}</p>
                </material-card>
              </v-flex>
              <v-flex
                v-if="dietasCarregadas"
                :md12="dietasCarregadas === null"
                :md6="dietasCarregadas !== null"
                xs12
                text-xs-center>
                <material-card
                  :text="strings[idioma].dietas_predicoes_salvas"
                  :color="colorCard">
                  <v-text-field
                    :label="strings[idioma].pesquisar"
                    v-model="searchDietas"
                    flat
                    hide-details
                    clearable
                    append-icon="mdi-magnify"
                    clear-icon="mdi-close"/>
                  <v-divider/>
                  <div style="padding: 0; margin: 0; max-height: 300px; width: 100%; overflow:auto;">

                    <v-card
                      style="padding: 0; margin: 0; width: 100%"
                      tile
                    >
                      <v-list
                        dense
                        flat
                        rounded>
                        <div color="primary">
                          <v-list-tile
                            v-for="dieta in dietasCarregadasFilter"
                            :key="dieta.id"
                            flat
                            color="primary"
                            @click="openDieta(dieta)">
                            <v-list-tile-avatar>
                              <v-icon

                                v-text="'mdi-folder'"
                              />
                            </v-list-tile-avatar>
                            <v-list-tile-content style="min-width: 70%">
                              <v-list-tile-title

                                class = "text-uppercase"
                              > {{ dieta.nome === '' ? `Dieta ${strings[idioma][dieta.animal.tipo]} salva automaticamente ` : dieta.nome }} </v-list-tile-title>
                              <v-list-tile-sub-title>{{ moment(dieta.time).format(strings[idioma].formato_datas_com_hora) }}  <small style="font-size: 9px;">( {{ isNaN(dieta.animal.peso_corporal_inicial) ? dieta.animal.peso_corporal_medio : (parseFloat(dieta.animal.peso_corporal_final) + parseFloat(dieta.animal.peso_corporal_inicial)) / 2 }} Kg. - {{ dieta.animal.ganho_medio_diario }} Kg.- {{ strings[idioma][dieta.animal.tipo] }} )</small></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </div>
                      </v-list>

                    </v-card>
                  </div>
                </material-card>
              </v-flex>

            </v-layout>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { getData, getDataEmpresa, updateData, getVinculados, getDietasNaoVinculados, getNaoVinculados, groupBy, createMD5 } from '@/utils/utils'
import Topo from './Topo'
import moment from 'moment'
import VueExcelXlsx from 'vue-excel-xlsx/VueExcelXlsx'
import {
  CRESCIMENTO_TERMINACAO,
  VACA,
  NAO_GESTANTE
} from '@/utils/types.js'
import {
  replaceSpecialChars
} from '@/utils/vuex'
export default {
  components: {
    Topo
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    empresa: Object
  },
  data () {
    return {
      exportando_dados: false,
      currUser: null,
      dietasCarregadas: [],
      naoVinculadosCarregados: [],
      searchDietas: null,
      searchColaboradores: null
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas', 'vinculados', 'naoVinculados']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 150) + 'px'
    },
    colorCard () {
      return 'indigo lighten-5'
    },
    CargosFilter () {
      return this.Cargos
    },
    Cargos () {
      let cargos = [{
        'nome': this.strings[this.idioma]['empresa_gestor'],
        'nivel': 0,
        'id': 'empresa_gestor'
      },
      {
        'nome': this.strings[this.idioma]['empresa_gerente_regional'],
        'nivel': 1,
        'id': 'empresa_gerente_regional'
      },
      {
        'nome': this.strings[this.idioma]['empresa_tecnico_venda'],
        'nivel': 2,
        'id': 'empresa_tecnico_venda'
      },
      {
        'nome': this.strings[this.idioma]['empresa_produtor_vinculado'],
        'nivel': 3,
        'id': 'empresa_produtor_vinculado'
      }
      ]
      return cargos
    },
    ehGestorOuAdmin () {
      return this.user.permissao === 0 || (this.user.emp_user && this.user.emp_user.acesso === 0)
    },
    ehGestor () {
      return (this.user.emp_user && this.user.emp_user.acesso === 0)
    },
    ehAdmin () {
      return this.user.permissao === 0
    },
    colaboradoresFilter () {
      console.log(this.naoVinculadosCarregados)
      if (this.searchColaboradores === null || this.searchColaboradores.trim() === '' || !this.naoVinculadosCarregados) return this.naoVinculadosCarregados
      return this.naoVinculadosCarregados.filter(p => new RegExp(replaceSpecialChars(this.searchColaboradores.toLowerCase()), 'i').test(p.id + '-' + p.email + '-' + p.NOME) && p.nome !== null && String(p.NOME).trim() !== '' && !p.EXCLUIDO)
    },
    dietasCarregadasFilter () {
      if (this.searchDietas === null || this.searchDietas.trim() === '') return this.dietasCarregadas
      return this.dietasCarregadas.filter(p => new RegExp(replaceSpecialChars(this.searchDietas.toLowerCase()), 'i').test(p.nome ? p.nome : p.name))
    }
  },
  mounted () {
    // this.go('/empresa')
    this.preload()
  },
  methods: {
    go (url) {
      window.location.href = url
    },
    preload () {
      if (!this.ehGestorOuAdmin) {
        alert('Acesso gestor é necessário para acessar esta página')
        return this.go('/empresa')
      }
      this.exportando_dados = true
      getNaoVinculados(this.$store.state, this.empresa.id, this.axios).then(res => {
        this.exportando_dados = false
        this.naoVinculadosCarregados = res
        console.log(res)
      })
    },
    openInfoVinculado (us) {
      // us.cargo = this.Cargos[us.emp_user.acesso].nome
      this.currUser = us
      let arr = us.dietas_gravadas.split(',,')
      this.dietasCarregadas = JSON.parse('[' + arr.join(',') + ']').map(dieta => {
        let dietaDetalhada = dieta
        dietaDetalhada.id = dieta.id
        return dietaDetalhada
      })
      setTimeout(() => {
        let target = document.getElementById('usr_area')
        target.scrollIntoView({
          block: 'end',
          behavior: 'smooth'
        })
        let parent = document.getElementById('conteudo')
        parent.scrollTop = target.offsetTop - parent.offsetTop
      }, 30)

    //   this.axios.post('dieta/getDietasByUser', { id: us.id }).then(res => {
    //     this.dietasCarregadas = res.data.data.map(dieta => {
    //       let dietaDetalhada = JSON.parse(dieta.dieta)
    //       dietaDetalhada.id = dieta.id
    //       return dietaDetalhada
    //     })
    //     setTimeout(() => {
    //       let target = document.getElementById('usr_area')
    //       target.scrollIntoView({
    //         block: 'end',
    //         behavior: 'smooth'
    //       })
    //       let parent = document.getElementById('conteudo')
    //       parent.scrollTop = target.offsetTop - parent.offsetTop
    //     }, 30)
    //   })
      // this.dietasCarregadas = us.dietas.reverse().map(u => JSON.parse(u.dieta))
    },
    desvincula (user) {
      let empresa = this.empresa
      let usuario = user
      let cargo = user.cargo
      console.log(this.Cargos.filter(c => cargo === c.nome)[0], cargo)
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      if (confirm(this.strings[this.idioma].voce_tem_certeza_disso)) {
        this.axios.post('empresa/desvincula', {
          id_empresa: empresa.id,
          id_pessoa: usuario.id,
          acesso: acesso
        }).then(response => {
          let msg = this.strings[this.idioma].desvinculado_com_sucesso
          let title = ''
          this.$store.commit('openOKModal', {
            title,
            msg
          })
          getVinculados(this.$store.state, this.empresa.id, this.axios)
          this.currUser = null
          this.dietasCarregadas = null
        })
      }
    },
    atualizaVinculo (user) {
      let empresa = this.empresa
      let usuario = user
      let cargo = user.cargo
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/vincula', {
        id_empresa: empresa.id,
        id_pessoa: usuario.id,
        acesso: acesso
      }).then(response => {
        let msg = this.strings[this.idioma].vinculo_atualizado
        let title = ''
        this.$store.commit('openOKModal', {
          title,
          msg
        })
        this.preload()
        this.getData()
        getVinculados(this.$store.state, this.empresa.id, this.axios)
        this.currUser = null
        this.dietasCarregadas = null
      })
    },
    moment (...args) {
      return moment(...args)
    },
    openDieta (dieta) {
      console.log(dieta)
      if (dieta.tipo_alimento_predicao && (dieta.tipo_alimento_predicao === 'MS' || dieta.tipo_alimento_predicao === 'MN')) {
        this.openPredicao(dieta)
      } else {
        this.$store.commit('loadDieta', dieta.name)
        if (!dieta.id) {
          setTimeout(() => {
            window.open('/formulacao-dieta?dieta=' + btoa(JSON.stringify(dieta)), '_blank')
          }, 300)
        } else {
          setTimeout(() => {
            this.$router.push('/formulacao-dieta?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id)))
          }, 300)
        }
      }
    },
    openPredicao (dieta) {
      this.$store.commit('loadPredicao', dieta.name)
      if (!dieta.id) {
        setTimeout(() => {
          window.open('/predicao-desempenho?predicao=' + btoa(JSON.stringify(dieta)), '_blank')
        }, 300)
      } else {
        setTimeout(() => {
          this.$router.push('/predicao-desempenho?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id)))
        }, 300)
      }
    }
  }
}
</script>
